<template>
    <a-modal
        :title="infoList.id ? $t('mobileConfig.adv_edit.title' /* 编辑广告 */) : $t('mobileConfig.adv_edit.add_adv' /* 添加广告 */)"
        v-model="visible"
        :width="600"
        :destroyOnClose="true"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-form :form="form">
            <a-form-item style="display: none">
                <a-input v-decorator="['id']" type="hidden"></a-input>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.banner_title' /* 标题 */)">
                <a-input
                    v-decorator="['title', { rules: [{ required: true, message: $t('mobileConfig.banner_title_required' /* 请输入标题 */) }] }]"
                    :placeholder="$t('mobileConfig.banner_title_required' /* 请输入标题 */)"
                ></a-input>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.banner_title_vice' /* 副标题 */)">
                <a-input
                    v-decorator="['title_vice', { rules: [{ required: false, message: $t('mobileConfig.banner_title_vice_required' /* 请输入副标题 */) }] }]"
                    :placeholder="$t('mobileConfig.banner_title_vice_required' /* 请输入副标题 */)"
                ></a-input>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.banner_image_scale' /* 缩略图 */)">
                <a-upload
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :action="uploadImageUrl"
                    :data="{ type: 1 }"
                    :before-upload="beforeUpload"
                    :headers="uploadHeaders"
                    @change="handleChange($event, { fieldName: 'img', loading: 'imgLoading' })"
                >
                    <input type="hidden" v-decorator="['img']" />
                    <a-spin v-if="form.getFieldValue('img')" :spinning="imgLoading">
                        <img style="max-width: 100%" :src="form.getFieldValue('img') | urlFilter(250)" alt="file" />
                    </a-spin>
                    <div v-else>
                        <a-icon :type="imgLoading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">
                            <!-- 上传图片 -->
                            {{ $t('layout.upload_image') }}
                        </div>
                    </div>
                </a-upload>
                <a-button type="link" style="margin-top: 5px" @click="handleRemoveImg" v-if="form.getFieldValue('img')">{{ $t('web.delete' /* 删除 */) }}</a-button>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.adv_edit.adv_url' /* 跳转地址 */)">
                <a-input
                    v-decorator="['url', { rules: [{ required: false, message: $t('mobileConfig.adv_edit.adv_url_required' /* 请输入链接地址 */) }] }]"
                    :placeholder="$t('mobileConfig.adv_edit.adv_url_required' /* 请输入链接地址 */)"
                ></a-input>
                <div slot="extra">
                    <span class="error-color">{{ $t('mobileConfig.adv_edit.adv_url_tips' /* 格式以 http:// 或 https:// 开头, 不填写则不跳转！ */) }}</span>
                </div>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
const fields = ['id', 'title', 'url', 'title_vice', 'img'];
import pick from 'lodash.pick';
import userApi from '@/request/apiList';
export default {
    name: 'AdvEdit',
    data() {
        return {
            form: this.$form.createForm(this),
            visible: false,
            infoList: {},
            seatId: null,
            seat_type: 0,
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            imgLoading: false
        };
    },
    methods: {
        show(seatId, record) {
            fields.forEach(v => this.form.getFieldDecorator(v));
            if (!record.id) {
                this.form.resetFields();
            } else {
                this.form.setFieldsValue(pick(record, fields));
            }
            this.visible = true;
            this.infoList = record;
            this.seatId = seatId;

            this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
            this.uploadHeaders['mid'] = this.$route.params.meeting_id;
            this.uploadHeaders['auth'] = this.$storage.get('token');
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    let data = {
                        language: this.$route.params.lang,
                        seat_id: this.seatId,
                        ...values
                    };
                    this.$request.post({ url: 'getMobileAdInfo', data }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('web.operate_success' /* 操作成功 */));
                            this.$emit('refresh');
                            this.visible = false;
                            this.form.resetFields();
                        }
                    });
                }
            });
        },
        // 上传修改
        handleChange(info, { fieldName, loading }) {
            if (info.file.status === 'uploading') {
                this[loading] = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[fieldName] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                this[loading] = false;
            }
        },

        // 上传前
        beforeUpload(file) {
            return new Promise((resolve, reject) => {
                // 头像的验证
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                if (!regFile) {
                    this.$message.error(this.$t('formConfig.only_upload_image' /* 您只能上传图像文件 */));
                    return reject(regFile);
                }
                return resolve(regFile);
            });
        },
        handleRemoveImg() {
            this.form.setFieldsValue({
                img: ''
            });
        },
        handleCancel() {
            this.visible = false;
            this.form.resetFields();
        }
    }
};
</script>

<style scoped lang="less"></style>
